<script lang="ts">
    import Popup from "@ts/ui/popups/popup.svelte"
    import Toasts from "@ts/toast.svelte.ts"

    const { link }: {link: string} = $props()

    let visible = $state(true)

    function Submit() {
        navigator.clipboard.writeText(link)
        .then(() => {
            visible = false
            Toasts.Add("Copied to clipboard", "success")
        })
        .catch(console.error)
    }
</script>

<Popup bind:visible>
    <input type="text" value={link} readonly>
    {#snippet buttons()}
        <button onclick={Submit}>Copy</button>
    {/snippet}
</Popup>

<style>
    input {
        width: 100%;
        min-width: min(400px, 80vw);
    }
</style>